import { Box, TouchableBox, useScaleFactor, useTheme } from "arkh";
import React from "react";

import { graphql, useFragment } from "react-relay";

import { TodoOverviewListItemMedium_Todo$key } from "./__generated__/TodoOverviewListItemMedium_Todo.graphql";
import { useEvent } from "../useEvent";

import { TodoOverviewListItemMediumDescription } from "./TodoOverviewListItemMediumDescription";
import { TodoOverviewListItemMediumFooter } from "./TodoOverviewListItemMediumFooter";

import { TodoOverviewListItemMediumStatusAndPrio } from "./TodoOverviewListItemMediumStatusAndPrio";

type TodoListItemProps = {
  onPress?: (todoId: string, focused: boolean) => void;
  todo: TodoOverviewListItemMedium_Todo$key;

  interactive?: undefined | false;
  omitSingleTeamName?: boolean;
  breadcrumbsExcludeRoot?: boolean;
  isFocused?: boolean;
};

function TodoOverviewListItemMediumC(props: TodoListItemProps) {
  const todo = useFragment(
    graphql`
      fragment TodoOverviewListItemMedium_Todo on Todo {
        id
        ...TodoOverviewListItemMediumDescription_Todo
        ...TodoOverviewListItemMediumFooter_Todo
        ...TodoOverviewListItemMediumStatusAndPrio_Todo
      }
    `,
    props.todo
  );

  const itemId = todo.id;

  const op = props.onPress;

  const onPress = useEvent(() => {
    op?.(itemId, props.isFocused ?? false);
  });
  const isFocused = props.isFocused;

  const sf = useScaleFactor();
  const bl = 4;
  const borderLeftWidth = Math.floor(sf * bl);

  const theme = useTheme();

  return (
    <TouchableBox
      spaceVertical="small"
      onPress={onPress}
      insets={{
        left: -bl,
      }}
      style={{
        overflow: "hidden",
        flexDirection: "row-reverse", // we want the status symbol to be on top, we cant use zIndex due to react native. So we reverse the order.
        alignItems: "center",
        borderLeftWidth: borderLeftWidth,

        borderColor: isFocused ? theme.primary : "transparent",
      }}
      spaceLeft="small"
    >
      <Box spaceHorizontal="small" style={{ flexDirection: "column", flex: 1 }}>
        <TodoOverviewListItemMediumDescription
          todo={todo}
          breadcrumbsExcludeRoot={props.breadcrumbsExcludeRoot}
        />
        <TodoOverviewListItemMediumFooter todo={todo} />
      </Box>
      <TodoOverviewListItemMediumStatusAndPrio
        interactive={props.interactive}
        todo={todo}
      />
    </TouchableBox>
  );
}

export const TodoOverviewListItemMedium = React.memo(
  TodoOverviewListItemMediumC
);
